import { render, staticRenderFns } from "./ResumeSelector.vue?vue&type=template&id=61c0c2e3&scoped=true&"
import script from "./ResumeSelector.vue?vue&type=script&lang=js&"
export * from "./ResumeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ResumeSelector.vue?vue&type=style&index=0&id=61c0c2e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0c2e3",
  null
  
)

export default component.exports